import {
  FETCH_DRIVERS_DATA,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  FETCH_DRIVERS_DETAILS_DATA,
  FETCH_DRIVERS_DETAILS_SUCCESS,
  FETCH_DRIVERS_DETAILS_FAILURE,
} from "./actionTypes";

export const fetchDriversData = () => ({
  type: FETCH_DRIVERS_DATA,
});

export const fetchDriversSuccess = (data) => ({
  type: FETCH_DRIVERS_SUCCESS,
  payload: data,
});

export const fetchDriversDetailsFailure = (error) => ({
  type: FETCH_DRIVERS_FAILURE,
  payload: error,
});

export const fetchDriversDetailsData = (id) => ({
  type: FETCH_DRIVERS_DETAILS_DATA,
  payload: id,
});

export const fetchDriversDetailsSuccess = (data) => ({
  type: FETCH_DRIVERS_DETAILS_SUCCESS,
  payload: data,
});

export const fetchDriversFailure = (error) => ({
  type: FETCH_DRIVERS_DETAILS_FAILURE,
  payload: error,
});
